import React, { Component } from 'react';
import { bool, func, instanceOf, node, shape } from 'prop-types';
import { connect } from 'react-redux';
import * as urls from '../../actions/urlTypes';

import {
  getDeStudies,
  resetDeState,
} from '../../actions/deActions/deTargetDashboardActions';
import DeLeftNavigations from '../../components/enablement/DeLeftNavigations';
import WarningIcon from '../WarningIcon';

class DE extends Component {
  componentDidMount() {
    if (this.props.isTPAccount || this.props.loginResponse.data.universityUser) {
      this.props.router.push(`${urls.APP_ROOT_URL}/essentials/crosstab`);
      return;
    }

    this.props.getDeStudies();
    if (!this.props.children) {
      this.props.router.push(`${urls.APP_ROOT_URL}/datahub/targets`);
    }
  }

  componentWillUnmount() {
    this.props.resetDeState();
  }

  render() {
    const { children, deStudies } = this.props;
    let renderHtml = <div style={{ padding: '40px' }}>loading...</div>;
    if (!deStudies.loading && deStudies.data.length === 0) {
      renderHtml = (
        <div className="no-study-message">
          <WarningIcon />
          <p>
            There are no studies currently assigned to this account. Please
            contact your MRI-Simmons account team for assistance.
          </p>
        </div>
      );
    }
    if (deStudies.data.length > 0) {
      renderHtml = children;
    }
    return (
      <div className="de--root">
        <DeLeftNavigations />
        {renderHtml}
      </div>
    );
  }
}

DE.propTypes = {
  children: node,
  resetDeState: func,
  getDeStudies: func,
  deStudies: shape({
    loading: bool,
    data: instanceOf(Array),
  }),
  router: instanceOf(Object),
  isTPAccount: bool,
  loginResponse: shape({
    data: shape({
      universityUser: bool,
    }),
  }),
};

DE.defaultProps = {
  isTPAccount: false,
  loginResponse: shape({
    data: shape({
      universityUser: false,
    }),
  }),
  deStudies: {
    loading: true,
    data: [],
  },
};

const mapStateToProps = ({ deImportDefiniton, login, account }) => {
  return {
    deStudies: deImportDefiniton.studies,
    loginResponse: login.loginResponse,
    isTPAccount: account.isTPAccount,
  };
};

export default connect(mapStateToProps, { resetDeState, getDeStudies })(DE);
